import { useGlobalConfig } from '../../hooks/configContext';
import FacebookLogo from '../../images/logos/social/facebook.svg';
import InstagramLogo from '../../images/logos/social/instagram.svg';
import LinkedInLogo from '../../images/logos/social/linkedin.svg';
import TwitterLogo from '../../images/logos/social/twitter.svg';
import YoutubeLogo from '../../images/logos/social/youtube.svg';

import {
  FACEBOOK_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  TWITTER_URL,
  YOUTUBE_URL,
} from '../../constants/otovoweb';

type Props = {
  type: 'dark' | 'light';
};

const SocialMediaLinks = ({ type }: Props) => {
  const {
    urls: {
      facebookUrl: SANITY_FACEBOOK_URL,
      instagramUrl: SANITY_INSTAGRAM_URL,
      linkedinUrl: SANITY_LINKEDIN_URL,
      twitterUrl: SANITY_TWITTER_URL,
      youtubeUrl: SANITY_YOUTUBE_URL,
    },
  } = useGlobalConfig();

  const socialMedia = [
    {
      name: 'facebook',
      icon: FacebookLogo,
      href: SANITY_FACEBOOK_URL || FACEBOOK_URL,
    },
    {
      name: 'instagram',
      icon: InstagramLogo,
      href: SANITY_INSTAGRAM_URL || INSTAGRAM_URL,
    },
    {
      name: 'twitter',
      icon: TwitterLogo,
      href: SANITY_TWITTER_URL || TWITTER_URL,
    },
    {
      name: 'linkedIn',
      icon: LinkedInLogo,
      href: SANITY_LINKEDIN_URL || LINKEDIN_URL,
    },
    {
      name: 'youtube',
      icon: YoutubeLogo,
      href: SANITY_YOUTUBE_URL || YOUTUBE_URL,
    },
  ];

  const className =
    type === 'dark'
      ? 'text-digital hover:text-digitalite'
      : 'text-lilac-20 hover:text-lilac-1';
  return (
    <div>
      <div className="flex space-x-4 md:order-2">
        {socialMedia.map((item) => (
          <a
            key={item.name}
            href={item.href}
            className={className}
            target="_blank"
            rel="noreferrer nofollow"
          >
            <span className="sr-only">{item.name}</span>
            <item.icon className="h-6 w-6" aria-hidden="true" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaLinks;
